__turbopack_context__.v({
  "black": "InDT2G_black",
  "black100": "InDT2G_black100",
  "black1000": "InDT2G_black1000",
  "black200": "InDT2G_black200",
  "black300": "InDT2G_black300",
  "black400": "InDT2G_black400",
  "black500": "InDT2G_black500",
  "black600": "InDT2G_black600",
  "black700": "InDT2G_black700",
  "black800": "InDT2G_black800",
  "black900": "InDT2G_black900",
  "blogPostExcerpt": "InDT2G_blogPostExcerpt",
  "blue200": "InDT2G_blue200",
  "blue400": "InDT2G_blue400",
  "blue600": "InDT2G_blue600",
  "blue800": "InDT2G_blue800",
  "blue900": "InDT2G_blue900",
  "flippedColumn": "InDT2G_flippedColumn",
  "green200": "InDT2G_green200",
  "green400": "InDT2G_green400",
  "green600": "InDT2G_green600",
  "green800": "InDT2G_green800",
  "green900": "InDT2G_green900",
  "label": "InDT2G_label",
  "pink200": "InDT2G_pink200",
  "pink400": "InDT2G_pink400",
  "pink600": "InDT2G_pink600",
  "pink800": "InDT2G_pink800",
  "purple200": "InDT2G_purple200",
  "purple400": "InDT2G_purple400",
  "purple600": "InDT2G_purple600",
  "purple800": "InDT2G_purple800",
  "purple900": "InDT2G_purple900",
  "red200": "InDT2G_red200",
  "red400": "InDT2G_red400",
  "red600": "InDT2G_red600",
  "red800": "InDT2G_red800",
  "red900": "InDT2G_red900",
  "showcase": "InDT2G_showcase",
  "showcaseArt": "InDT2G_showcaseArt",
  "showcaseBrushstroke": "InDT2G_showcaseBrushstroke",
  "showcaseContainer": "InDT2G_showcaseContainer",
  "showcaseCta": "InDT2G_showcaseCta",
  "showcaseDescription": "InDT2G_showcaseDescription",
  "showcaseDropshadow": "InDT2G_showcaseDropshadow",
  "showcaseExhibit": "InDT2G_showcaseExhibit",
  "showcaseFlipped": "InDT2G_showcaseFlipped",
  "showcaseImage": "InDT2G_showcaseImage",
  "showcaseImageFullWidth": "InDT2G_showcaseImageFullWidth",
  "showcaseObjects": "InDT2G_showcaseObjects",
  "showcaseSetup": "InDT2G_showcaseSetup",
  "showcaseTitle": "InDT2G_showcaseTitle",
  "showcaseVideo": "InDT2G_showcaseVideo",
  "showcaseVideoFullWidth": "InDT2G_showcaseVideoFullWidth",
  "showcaseWeb3Theme": "InDT2G_showcaseWeb3Theme",
  "sky1000": "InDT2G_sky1000",
  "useCaseLendingRed": "InDT2G_useCaseLendingRed",
  "white": "InDT2G_white",
  "yellow200": "InDT2G_yellow200",
  "yellow400": "InDT2G_yellow400",
  "yellow600": "InDT2G_yellow600",
  "yellow800": "InDT2G_yellow800",
  "yellow900": "InDT2G_yellow900",
});
